import { FC } from 'react';
import Link from '@base/lib/Link';
import site from 'pro/config/site';
import cn from 'classnames';

const list = [
    { title: 'Instagram', url: site.sns.instagram },
    { title: 'Facebook', url: site.sns.facebook },
    { title: 'Youtube', url: site.sns.youtube },
];

export const FooterFollow: FC = () => {
    return (
        <div className={'mb-64'}>
            <h3 className={'mb-24'}>FOLLOW</h3>
            <ul className={'text-18'}>
                {list.map((item, index) => (
                    <li key={item.title} className={cn({ 'mb-8': index < list.length - 1 })}>
                        <Link href={item.url} target={'_blank'}>
                            {item.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
};
